{
  "intro": "Виртуальные машины этого проекта Hetzner. Сервер оплачивается почасово с момента создания и до удаления — в том числе когда он выключен. Откройте сервер, чтобы включить или выключить его, переустановить систему, сменить тариф или посмотреть нагрузку.",
  "detailIntro": "Всё об одном сервере: адреса, питание, режим восстановления, операционная система, тариф, резервные копии и нагрузка. Изменения выполняются в Hetzner в фоне, ход выполнения виден здесь.",
  "create": "Создать сервер",
  "empty": "Серверов пока нет",
  "emptyLead": "Сервер — это виртуальная машина со своим публичным адресом. Выберите тариф, расположение и операционную систему: через минуту сервер готов, а оплата идёт почасово, пока вы его не удалите.",
  "filter": "Фильтр серверов",
  "filterPlaceholder": "Имя или IP-адрес",
  "statusFilter": "Состояние",
  "anyStatus": "Любое состояние",
  "noMatch": "Под фильтр не подходит ни один сервер.",
  "name": "Имя",
  "nameHint": "Становится именем хоста: латинские буквы, цифры, точки и дефисы, до 63 символов.",
  "nameInvalid": "Допустимы латинские буквы, цифры, точки и дефисы; в начале и в конце — буква или цифра.",
  "statusColumn": "Состояние",
  "publicIp": "Публичный адрес",
  "privateIp": "Частный IP",
  "noIpv4": "Только IPv6",
  "region": "Расположение",
  "created": "Создан",
  "open": "Открыть",
  "actions": "Действия",
  "gb": "ГБ",
  "ipv4": "IPv4-адрес",
  "ipv6": "IPv6-сеть",
  "copy": "Скопировать {{what}}",
  "on": "Включён",
  "off": "Выключен",
  "powerSwitch": "Питание",
  "notSwitchable": "Дождитесь, пока сервер включится или выключится.",
  "busy": "На этом сервере ещё выполняется другое изменение. Дождитесь его окончания.",
  "notRunning": "Только когда сервер работает.",
  "notOff": "Только когда сервер выключен.",
  "rename": "Переименовать",
  "renameLead": "По имени вы находите сервер здесь; при новой установке системы провайдер делает его именем хоста.",
  "renamed": "Сервер переименован в «{{name}}»",
  "notFound": "Сервер не найден",
  "notFoundLead": "Такого сервера в проекте нет — возможно, его удалили.",
  "backToList": "К списку серверов",
  "tabsLabel": "Разделы сервера",
  "progress": "{{what}}… {{progress}}\u00a0%",
  "started": "{{what}}: начато для «{{name}}»",
  "done": "{{what}}: готово для «{{name}}»",
  "failed": "{{what}}: не удалось для «{{name}}». Откройте сервер, чтобы увидеть его состояние.",
  "noActivity": "Через CloudServer с этим сервером пока ничего не делали.",
  "status": {
    "initializing": "Создаётся",
    "starting": "Включается",
    "running": "Работает",
    "stopping": "Выключается",
    "off": "Выключен",
    "rebuilding": "Переустанавливается",
    "migrating": "Переносится",
    "deleting": "Удаляется",
    "unknown": "Неизвестно"
  },
  "activityStatus": {
    "running": "Выполняется",
    "success": "Готово",
    "error": "Ошибка"
  },
  "kinds": {
    "create": "Создание",
    "update": "Имя или метки",
    "delete": "Удаление",
    "power_on": "Включение",
    "shutdown": "Завершение работы",
    "power_off": "Выключение питания",
    "reboot": "Перезагрузка",
    "reset": "Сброс",
    "enable_rescue": "Включение режима восстановления",
    "disable_rescue": "Отключение режима восстановления",
    "reset_password": "Сброс пароля root",
    "rebuild": "Переустановка",
    "change_type": "Смена типа",
    "enable_backups": "Включение резервного копирования",
    "disable_backups": "Отключение резервного копирования",
    "create_snapshot": "Снимок",
    "change_protection": "Изменение защиты",
    "attach_iso": "Подключение ISO",
    "detach_iso": "Отключение ISO"
  },
  "tabs": {
    "overview": "Обзор",
    "networking": "Сеть",
    "power": "Питание",
    "rescue": "Восстановление",
    "rebuild": "Переустановка",
    "change-type": "Смена тарифа",
    "backups": "Копии и снимки",
    "metrics": "Графики",
    "autopilot": "Автопилот",
    "packages": "Приложения",
    "app": "Приложение",
    "alerts": "Оповещения",
    "delete": "Удаление",
    "iso": "ISO-образ",
    "volumes": "Диски"
  },
  "protection": {
    "badge": "Защищён",
    "turnOn": "Включить защиту",
    "turnOff": "Снять защиту"
  },
  "overview": {
    "specs": "Конфигурация",
    "cores": "vCPU",
    "shared": "общие",
    "dedicated": "выделенные",
    "memory": "Память",
    "disk": "Диск",
    "architecture": "Архитектура",
    "image": "Операционная система",
    "noImage": "Образ больше недоступен",
    "region": "Расположение",
    "zone": "Сетевая зона {{zone}}",
    "created": "Создан",
    "backups": "Резервные копии",
    "backupsOn": "Ежедневно, окно {{window}} UTC",
    "backupsOff": "Выключены",
    "iso": "Подключённый ISO",
    "traffic": "Трафик за месяц",
    "trafficHint": "В лимит входит только исходящий трафик, входящий бесплатен. Каждый терабайт сверх лимита оплачивается отдельно.",
    "trafficUsed": "Использовано {{used}} из {{included}} (исходящий)",
    "trafficIn": "Входящий: {{value}} (не оплачивается)",
    "activity": "История"
  },
  "labels": {
    "title": "Метки",
    "why": "Пары «ключ=значение», которые вы задаёте сами, например env=production. По ним удобно искать серверы и применять файрволы к группам серверов.",
    "none": "Меток нет.",
    "edit": "Изменить метки",
    "lead": "По одной метке в строке, в виде ключ=значение. Строка без «=» — метка без значения.",
    "hint": "Ключи и значения — до 63 символов, по краям латинские буквы или цифры, внутри также «-», «_» и «.».",
    "invalid": "Недопустимый ключ или значение. Проверьте правила под полем.",
    "saved": "Метки сохранены"
  },
  "networking": {
    "public": "Публичные адреса",
    "noIpv4": "Публичного IPv4-адреса нет: сервер доступен только по IPv6.",
    "reverseDns": "Обратная DNS-запись",
    "reverseDnsHint": "Имя хоста, которое адрес возвращает при обратном запросе. Его проверяют почтовые серверы; задаётся на странице IP-адресов.",
    "noReverseDns": "Не задана",
    "ipv6Hint": "Каждый сервер получает целую сеть /64; по умолчанию он использует первый адрес из неё.",
    "noIpv6": "IPv6-сети нет.",
    "ipsElsewhere": "Адреса, обратные записи и их защита настраиваются на странице IP-адресов.",
    "private": "Частные сети",
    "noPrivate": "Сервер не подключён к частной сети.",
    "networkRef": "Сеть {{ref}}",
    "firewalls": "Файрволы",
    "noFirewalls": "Файрвол не применён: доступен любой порт, который открыла операционная система.",
    "firewallRef": "Файрвол {{ref}}"
  },
  "power": {
    "lead": "Завершение работы просит операционную систему остановиться — как короткое нажатие кнопки питания; выключение питания обесточивает сервер сразу. Выключенный сервер всё равно оплачивается — чтобы расходы прекратились, удалите его.",
    "stillBilled": "Выключенный сервер оплачивается полностью.",
    "power-on": {
      "action": "Включить",
      "explain": "Запускает сервер. Операционная система загружается за несколько секунд.",
      "started": "Включаем «{{name}}»"
    },
    "shutdown": {
      "action": "Завершить работу",
      "explain": "Просит операционную систему корректно остановиться (сигнал ACPI). Программы успевают сохранить данные. Если система не реагирует на сигнал, сервер останется включённым.",
      "started": "Завершаем работу «{{name}}»",
      "confirmTitle": "Завершить работу «{{name}}»?",
      "consequence": "Операционная система получит команду остановиться; службы на сервере станут недоступны."
    },
    "power-off": {
      "action": "Выключить питание",
      "explain": "Обесточивает сервер сразу, как выдернуть вилку из розетки. Данные, ещё не записанные на диск, пропадут. Используйте, когда система больше не отвечает.",
      "started": "Выключаем питание «{{name}}»",
      "confirmTitle": "Выключить питание «{{name}}»?",
      "consequence": "Питание отключится сразу: данные, ещё не записанные на диск, пропадут."
    },
    "reboot": {
      "action": "Перезагрузить",
      "explain": "Просит операционную систему корректно перезапуститься. Ненадолго сервер станет недоступен.",
      "started": "Перезагружаем «{{name}}»",
      "confirmTitle": "Перезагрузить «{{name}}»?",
      "consequence": "Операционная система перезапустится; пока она загружается, службы недоступны."
    },
    "reset": {
      "action": "Сбросить",
      "explain": "Жёстко перезапускает сервер, не спрашивая операционную систему. Данные, ещё не записанные на диск, пропадут.",
      "started": "Сбрасываем «{{name}}»",
      "confirmTitle": "Сбросить «{{name}}»?",
      "consequence": "Сервер перезапустится сразу, как от кнопки Reset: несохранённые данные пропадут."
    }
  },
  "rescue": {
    "title": "Режим восстановления",
    "badge": "Восстановление включено",
    "lead": "Небольшой Linux, который загружается по сети вместо диска сервера. С его помощью чинят систему, которая перестала загружаться, или достают файлы: диск остаётся нетронутым, его можно подключить оттуда.",
    "keys": "SSH-ключи для режима восстановления",
    "noKeys": "В проекте нет SSH-ключей: войти можно будет по паролю root, который покажется после включения.",
    "keysHint": "Выбранные ключи смогут входить как root. Пароль root тоже будет создан.",
    "thenReboot": "Режим восстановления запустится при следующей перезагрузке, и только один раз: после включения перезагрузите сервер.",
    "enable": "Включить восстановление",
    "enabledNow": "Режим восстановления включён: при следующей перезагрузке сервер загрузит систему восстановления.",
    "disable": "Отключить восстановление"
  },
  "password": {
    "title": "Новый пароль root",
    "lead": "С ним можно войти как root по SSH или в консоли.",
    "label": "пароль root",
    "once": "Скопируйте его сейчас. CloudServer его не хранит и показать снова не сможет.",
    "saved": "Я сохранил пароль",
    "resetTitle": "Сброс пароля root",
    "resetLead": "Задаёт новый случайный пароль root на работающем сервере. Нужен гостевой агент QEMU — он есть в образах провайдера.",
    "reset": "Сбросить пароль",
    "needsRunning": "Сервер должен работать.",
    "confirmTitle": "Сбросить пароль root на «{{name}}»?",
    "consequenceOld": "Текущий пароль root перестанет действовать.",
    "consequenceKeys": "SSH-ключи продолжат работать; новый пароль покажется один раз."
  },
  "rebuild": {
    "title": "Переустановка",
    "lead": "Ставит на сервер свежую операционную систему. Имя, тариф, адреса и сети сохраняются; всё содержимое диска стирается.",
    "image": "Новая операционная система",
    "choose": "Выберите образ…",
    "app": "{{name}} (приложение)",
    "current": "Сейчас: {{image}}",
    "protected": "Включена защита от переустановки. Сначала снимите её в меню действий.",
    "action": "Переустановить сервер",
    "confirmTitle": "Переустановить «{{name}}»?",
    "consequenceData": "Всё содержимое диска сервера будет стёрто без возможности восстановления.",
    "consequenceImage": "Будет установлен образ {{image}}; новый пароль root покажется один раз.",
    "consequenceKeep": "Имя, тариф, IP-адреса и сети останутся прежними.",
    "leadOwn": "Или верните сервер к сохранённому состоянию: снимки и резервные копии проекта подходят, если совпадает архитектура и хватает диска.",
    "groupCatalogue": "Операционные системы и приложения",
    "groupSnapshots": "Снимки проекта",
    "groupBackups": "Резервные копии",
    "own": "{{name}}, {{date}}",
    "ownBackup": "{{name}} (сервер {{server}}), {{date}}"
  },
  "changeType": {
    "title": "Смена тарифа",
    "lead": "Даёт серверу больше или меньше vCPU и памяти. Сервер должен быть выключен; смена занимает несколько минут.",
    "current": "Сейчас: {{type}}, {{price}} в месяц",
    "mustBeOff": "Сначала выключите сервер: тариф меняется только у выключенного сервера.",
    "choose": "Новый тариф",
    "none": "В этом расположении нет других тарифов с этой архитектурой.",
    "spec": "{{cores}}\u00a0vCPU · {{memory}}\u00a0ГБ · {{disk}}\u00a0ГБ",
    "diskTooSmall": "Диск этого тарифа меньше текущего диска сервера.",
    "upgradeDisk": "Увеличить и диск",
    "upgradeDiskHint": "Без этого меняются только vCPU и память, и позже можно вернуться на меньший тариф. С этим диск вырастет до нового размера, и вернуться на тариф с меньшим диском будет уже нельзя.",
    "netPrices": "Цены за месяц без НДС; оплата почасовая.",
    "action": "Сменить тариф",
    "confirmTitle": "Перевести «{{name}}» на {{type}}?",
    "consequencePrice": "Дальше сервер стоит {{price}} в месяц.",
    "consequenceDisk": "Диск увеличится: перейти обратно на тариф с меньшим диском будет нельзя.",
    "consequenceNoDisk": "Размер диска не изменится, поэтому позже можно вернуться обратно.",
    "consequenceOff": "Сервер останется выключенным, пока вы его не включите."
  },
  "backups": {
    "title": "Автоматические резервные копии",
    "on": "Включены",
    "off": "Выключены",
    "lead": "Hetzner раз в сутки копирует весь диск и хранит семь последних копий. Из копии можно откатить сервер назад или создать новый сервер.",
    "price": "Стоит {{percent}}\u00a0% от цены сервера: {{price}} в месяц.",
    "pricePercent": "Стоит {{percent}}\u00a0% от цены сервера.",
    "window": "Копия делается ежедневно в окне {{window}} UTC.",
    "enable": "Включить резервное копирование",
    "disable": "Отключить резервное копирование",
    "disableTitle": "Отключить резервное копирование «{{name}}»?",
    "disableConsequence": "Все существующие резервные копии этого сервера сразу удалятся.",
    "snapshots": "Снимки",
    "snapshotsLead": "Снимок — копия диска, которую вы делаете сами, например перед обновлением. Он хранится, пока вы его не удалите, и из него можно создавать новые серверы.",
    "snapshotPrice": "Оплачивается по объёму: {{price}} за ГБ в месяц.",
    "snapshotTitle": "Сделать снимок",
    "snapshotLead": "Сервер продолжит работать. Чтобы получить целостную копию нагруженной базы данных, сначала завершите работу сервера.",
    "description": "Описание",
    "descriptionPlaceholder": "Перед обновлением до версии 2",
    "descriptionHint": "Чтобы потом узнать снимок.",
    "snapshotCreate": "Сделать снимок",
    "allImages": "Все снимки и копии проекта",
    "list": "Резервные копии сервера",
    "listHint": "Hetzner хранит семь последних суточных копий; новая заменяет самую старую. Копию, которую нужно оставить надолго, сохраните как снимок.",
    "noneYet": "Копий пока нет: первая появится в ближайшее окно резервного копирования.",
    "noneOff": "Резервное копирование выключено, копий нет.",
    "snapshotList": "Снимки этого сервера",
    "noSnapshots": "Снимков этого сервера пока нет.",
    "disableKeep": "Копий удалится: {{count}}. Нужную сначала сохраните как снимок."
  },
  "metrics": {
    "lead": "Нагрузка на сервер, как её видит Hetzner снаружи. Каждая точка — среднее значение за свой интервал.",
    "range": "Период",
    "ranges": {
      "1h": "1 час",
      "24h": "24 часа",
      "7d": "7 дней",
      "30d": "30 дней"
    },
    "cpu": "Процессор",
    "cpuLabel": "Загрузка",
    "diskIops": "Операции с диском",
    "diskBandwidth": "Скорость диска",
    "networkPps": "Сетевые пакеты",
    "networkBandwidth": "Сетевой трафик",
    "read": "Чтение",
    "write": "Запись",
    "in": "Входящий",
    "out": "Исходящий",
    "empty": "За этот период данных нет: сервер был выключен или только что создан.",
    "units": {
      "iops": "{{value}} IOPS",
      "pps": "{{value}} пак/с",
      "b": "{{value}} Б/с",
      "kb": "{{value}}\u00a0КБ/с",
      "mb": "{{value}}\u00a0МБ/с",
      "gb": "{{value}}\u00a0ГБ/с"
    }
  },
  "delete": {
    "action": "Удалить сервер",
    "title": "Удаление сервера",
    "confirmTitle": "Удалить «{{name}}»?",
    "consequenceData": "Сервер и всё содержимое его диска удалятся навсегда. Резервные копии удалятся вместе с ним, снимки останутся.",
    "consequenceIps": "Его публичные IP-адреса удалятся вместе с ним, если у них включено автоудаление (так по умолчанию у адресов, созданных вместе с сервером); остальные останутся в проекте неназначенными.",
    "consequenceBilling": "Оплата прекратится, когда удаление завершится.",
    "protected": "Включена защита от удаления",
    "protectedLead": "Защита не даёт удалить сервер по ошибке. Если вы действительно хотите его удалить, сначала снимите её.",
    "started": "Удаляем «{{name}}»",
    "ipsTitle": "Публичные адреса сервера",
    "ipsLead": "Отмеченные адреса останутся в проекте неназначенными: их можно позже назначить другому серверу того же региона, и DNS-записи менять не придётся. Неотмеченные удалятся вместе с сервером, и вернуть их будет нельзя.",
    "keepIp": "Сохранить {{address}}",
    "keepIpv4Cost": "IPv4 оплачивается, пока его не удалят, даже без сервера: {{price}} в месяц.",
    "keepIpv4Billed": "IPv4 оплачивается помесячно, пока его не удалят, даже без сервера.",
    "keepIpv6Free": "IPv6 бесплатен.",
    "ipStays": "{{address}} останется в проекте: автоудаление у него выключено."
  },
  "iso": {
    "title": "ISO-образ",
    "badge": "Подключён ISO",
    "lead": "ISO-образ подключается к серверу как виртуальный CD-привод: установщик другой системы, live-система или диск с драйверами. Пока он подключён, сервер при каждой загрузке сначала пробует загрузиться с него, а уже потом с диска.",
    "stepAttach": "Выберите образ и подключите его.",
    "stepReboot": "Перезагрузите сервер: он загрузится с ISO.",
    "stepConsole": "Откройте консоль и пройдите установку или сделайте, что нужно.",
    "stepDetach": "Отключите ISO, когда закончите, иначе сервер снова загрузится с него.",
    "attachedNow": "Подключён образ «{{name}}». При следующей загрузке сервер загрузится с него.",
    "reboot": "Перезагрузить",
    "detach": "Отключить ISO",
    "attachTitle": "Подключить образ",
    "replaceTitle": "Заменить образ",
    "choose": "Образ",
    "placeholder": "Выберите образ…",
    "groupOwn": "Образы проекта",
    "groupPublic": "Общие образы",
    "until": "{{name}} (доступен до {{date}})",
    "architecture": "Показаны образы для архитектуры сервера ({{arch}}) и универсальные.",
    "none": "Для архитектуры этого сервера ISO-образов нет.",
    "replaces": "Подключённый сейчас «{{name}}» будет отключён.",
    "attach": "Подключить ISO"
  },
  "appliance": {
    "label": "Управляемый прибор",
    "badge": "Управляемый прибор",
    "title": "Управляемый прибор. Ручные изменения будут перезаписаны.",
    "text": "Этот сервер создало и ведёт приложение «{{name}}». Пересоздать, сменить тип, снять защиту или удалить его можно только через приложение. Консоль — для диагностики: каждое её открытие записывается в журнал аудита.",
    "drift": "Изменено у провайдера: {{checks}}. Вернуть как было можно на странице приложения.",
    "checks": {
      "label": "метка",
      "protection": "защита",
      "type": "тип"
    },
    "open": "Открыть «{{name}}»",
    "onlyPackage": "Управляемый прибор: только через приложение",
    "show": "Показать управляемые приборы ({{count}})"
  }
}
